import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/excellent',
        name: 'excellent',
        component: resolve => require(['@/views/excellent/index'], resolve),
        meta: {
          title: '增强能力',
          breadLevel: 0,
          icon: 'icon-strength',
          auth: auth.excellent
        }
      },
      {
        path: '/excellent/deploymentManual',
        name: 'deploymentManual',
        component: resolve => require(['@/views/excellent/deploymentManual'], resolve),
        meta: {
          title: '部署说明文档',
          breadLevel: 1
        }
      },
      //调用测试
      {
        path: '/excellent/callTest',
        name: 'callTest',
        component: resolve => require(['@/views/excellent/callTest'], resolve),
        meta: {
          title: '调用测试',
          breadLevel: 1
        }
      }
    ]
  }
]

export default routes
